import { Component, OnInit, OnDestroy } from '@angular/core';
import { SmsService } from 'src/app/services/sms-service/smsservice';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SMSBasic } from 'src/app/models/turns-models/turns-sms-basic.model';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-sms-sms-dashboard',
  templateUrl: './sms-sms-dashboard.component.html',
  styleUrls: ['./sms-sms-dashboard.component.scss']
})
export class SmsSmsDashboardComponent implements OnInit, OnDestroy {

  sms: SMSBasic;
  getSmsSubscriptionRefresh: Subscription;
  getSmsInfoSubscription: Subscription;

  constructor(private smsService: SmsService,
              private activatedRoute: ActivatedRoute,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getSmsInfo();
    this.getSmsSubscriptionRefresh = this.smsService.refreshSmsListen().subscribe(
      (res) => {
        this.getSmsInfo();
      }
    );
  }

  public getSmsInfo() {
    const internalId = this.activatedRoute.snapshot.params['smsid'];
    this.getSmsInfoSubscription = this.smsService.getSmsInfo(internalId).subscribe(
      (o) => {
        this.sms = o;
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-sms', 'sms-page.sms detail', '/account/smss', [new BRoute('account-page.account', '/account'), new BRoute('sms-page.smss', '/account/smss'), new BRoute('sms-page.sms detail')]));
  }

  ngOnDestroy() {
    if (this.getSmsSubscriptionRefresh) { this.getSmsSubscriptionRefresh.unsubscribe(); }
    if (this.getSmsInfoSubscription) { this.getSmsInfoSubscription.unsubscribe(); }
  }

}
